import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import env from 'Env';
import ShowcaseCarousel from 'Features/Product/components/ShowcaseCarousel/ShowcaseCarousel';
import ShowcaseCriticReviewCard from 'Features/Product/components/ShowcaseCriticReviews/ShowcaseCriticReviewCard';

import 'Features/Product/components/ShowcaseCriticReviews/ShowcaseCriticReviews.scss';

export default function ShowcaseCriticReviews({ product }) {
  const recommendedThreshold = env.percentRecommendedThreshold;
  const showMetaCritic = get(product, 'metaCritic.score') >= recommendedThreshold && get(product, 'metaCritic.reviews.length', 0) >= 3;
  const metacriticData = get(product, 'metaCritic', {});

  if (!showMetaCritic) return null;

  const slideWidths = {
    xs: 300,
    sm: 350,
    md: 350,
    lg: 400,
    xl: 358,
    xxl: 420,
  };

  return (
    <div className="ShowcaseCriticReviews">
      <ShowcaseCarousel
        slideWidths={slideWidths}
        title="Critic Reviews"
        appearsOn="critic"
        metacriticData={metacriticData}
      >
        {product.metaCritic.reviews.slice(0, 3).map(review =>
          <ShowcaseCriticReviewCard key={review.url} review={review} />,
        )}
      </ShowcaseCarousel>
    </div>
  );
}

ShowcaseCriticReviews.propTypes = {
  product: PropTypes.shape(),
};

ShowcaseCriticReviews.defaultProps = {
  product: {},
};
